module.exports = __webpack_public_path__ + "static/media/CloudRight.3d69ed9d.svg";